import styled from 'styled-components';

import Main from '../Main';

export default styled(Main)`
	--sidebar-width: var(--px-400);
	--content-h-pad: var(--spacing-xxx-large);
	--content-v-pad: var(--spacing-x-large);
	position: relative;

	&.collapsed {
		--sidebar-width: var(--px-35);
		& > aside > * {
			display: none;
		}
	}

	& > aside {
		width: var(--sidebar-width);
		min-width: var(--sidebar-width);
		border-right: var(--template-separator);
		transition: all 0.2s ease-in-out;
	}

	& > section {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-width: 0;
		& > .customScrollbar {
			min-height: 100%;
		}
	}

	.collapse-expand {
		position: absolute;
		left: var(--sidebar-width);
		top: var(--spacing-x-large);
		transform: translateX(-50%);
		z-index: 1;
		transition: all 0.2s ease-in-out;
		border-color: var(--header--border-color);
		background-color: var(--neutrals-bg-gradient1);
	}
`;
